<template>
  <div class="register">
    <div class="box">
      <!--<div class="imgWrap">-->
        <!--<div :class="{left:true,leftSelected:imgIndexKey===0}" @click="imgIndexKey = 0" >-->
          <!--<span>我是老师</span>-->
        <!--</div>-->
        <!--<div :class="{right:true,rightSelected:imgIndexKey===1}" @click="imgIndexKey = 1" >-->
          <!--<span>我是学生</span>-->
        <!--</div>-->
      <!--</div>-->
      <!--<div style="text-align: center;line-height: 1rem">-->
        <!--<p style="color: #FF0000;font-size: .3rem;font-weight: bolder">温馨提示：如果您有期刊投稿需求请选择“我是老师”</p>-->
      <!--</div>-->

      <van-form class="form">
        <van-field
          v-model="username"
          :key="registerType"
          :placeholder="popoverIndex.text === '手机号注册'?'请输入手机号码':'请输入您的邮箱号'"
        >
          <template #left-icon>
            <van-popover v-model="showPopover" trigger="click" :actions="actions" @select="select">
              <template #reference>
                <img :src="popoverIndex.src" alt="">
                <img :class="{arrow:true,arrowTop:!showPopover}" :src="require('@/assets/images/icon_arrow_01.png')" alt="">
              </template>
            </van-popover>
          </template>
        </van-field>
        <van-field
          v-model="code"
          placeholder="请输入验证码"
        >
          <template #left-icon>
            <img :src="require('@/assets/images/icon_chield_01.png')" alt="">
          </template>
          <template #button>
            <GetCode ref="GetCode" :disable="disable" :obj="{startText:'获取验证码'}" @click="getCode" />
          </template>
        </van-field>
        <van-field
          v-model="password1"
          placeholder="请设置登录密码"
          type="password"
        >
          <template #left-icon>
            <img :src="require('@/assets/images/icon_lock_03.png')" alt="">
          </template>
        </van-field>
        <van-field
          v-model="password2"
          placeholder="请再次输入密码"
          type="password"
        >
          <template #left-icon>
            <img :src="require('@/assets/images/icon_lock_02.png')" alt="">
          </template>
        </van-field>
      </van-form>
      <button class="submit" @click="submit">立即注册</button>
    </div>
    <div class="checkbox">
      <span @click="checked = !checked" :class="{checked}"></span>
      勾选即代表你已经同意<sub class="link" @click="$router.push({ name:'HelpCenter', params: { type : 4 } });">《用户服务协议》</sub>和
      <sub class="link" @click="$router.push({ name:'HelpCenter', params: { type : 9 } });">《隐私政策》</sub>
    </div>
  </div>
</template>

<script>
import md5 from 'md5';
import { Form, Field, Popover } from 'vant';
import { GetCode } from '@/components';
export default {
  name: 'register',
  components: { 'van-form': Form, 'van-field': Field, 'van-popover': Popover, GetCode },
  data () {
    return {
      showPopover: false,
      popoverIndex: { text: '手机号注册', src: require('@/assets/images/icon_phone_01.png') },
      actions: [
        { text: '手机号注册', src: require('@/assets/images/icon_phone_01.png') },
        { text: '邮箱注册', src: require('@/assets/images/icon_email_01.png') }
      ],
      imgIndexKey: 0,
      registerType: 1,
      username: '',
      code: '',
      password1: '',
      password2: '',
      checked: false,
      disable: false
    };
  },
  methods: {
    select (action) {
      this.popoverIndex = action;
      this.registerType = action.text === '手机号注册' ? 1 : 0;
      this.username = '';
    },

    /* 发送验证码 */
    getCode () {
      const { $utils, username, registerType } = this;
      if ($utils.verifyEmpty(username, '请输入手机号码或邮箱')) {
        if (registerType === 1) {
          this.$refs.GetCode.toSend(() => {
            this.$http.get('mobile/sendRegisterCode', { params: { mobile: username }, showLoading: true, customError: true }).then((res) => {
            }).catch((err) => {
              let e = err.data || {};
              if (e.result === -1) {
                $utils.failToast({
                  message: e.msg
                });
                this.disable = true;
              }
              return false;
            });
          });
        } else {
          if ($utils.verifyEmail(username)) {
            this.$refs.GetCode.toSend(() => {
              this.$http.get('email/sendBindEmailCode', { params: { email: username }, showLoading: true }).then((res) => {
              });
            });
          }
        }

      }
    },
    submit () {
      const { $utils, imgIndexKey, registerType, username, code, password1, password2, checked } = this;
      if ($utils.verifyEmpty(username, '请输入手机号码或邮箱') &&
      $utils.verifyEmpty(code, '请输入验证码') &&
      $utils.verifyEmpty(password1, '请设置登陆密码') &&
      $utils.verifyEmpty(password2, '请再次输入密码') &&
      $utils.verifySame(password1, password2, '两次密码输入不一致!') &&
      $utils.verifyEmpty(checked, '请勾选用户服务协议协议和隐私政策协议')) {
        const params = { password: md5(password1), role: imgIndexKey, registerType };
        if (registerType === 1) {
          params.mobile = username;
          params.mobileCode = code;
        } else {
          params.email = username;
          params.emailCode = code;
        }
        this.$http.post('/security/h5/apply',
          params,
          { showLoading: true, loadingText: '修改中...' }
        ).then((res) => {
          $utils.successToast({
            message: '注册成功',
            onClose: () => {
              this.$router.push({ name: 'Login' });
            }
          });
        });
      }
    }
  }
};
</script>

<style lang="less" scoped>
.register {
  width: 100%;
  height: 100%;
  background: url('~@/assets/images/bg_login_01.png') no-repeat center center;
  overflow: hidden;
  .box {
    margin: 52px auto 0;
    width: 694px;
    height: 974px;
    background: #fff;
    box-shadow: 0px 6px 60px rgba(95, 169, 255, 0.1);
    border-radius: 40px;
    overflow: hidden;
    .imgWrap {
      margin-top: 40px;
      display: flex;
      align-items: center;
      justify-content: space-around;
      font-size: 28px;
      line-height: 40px;
      color: #C1C1C1;
      .left {
        position: relative;
        width: 286px;
        height: 122px;
        background: url('~@/assets/images/img_teacher_01.png') no-repeat center center/cover;
        span {
          position: absolute;
          top: 58px;
          right: 40px;
        }
      }
      .leftSelected {
        color: #fff;
        background: url('~@/assets/images/img_teacher_02.png') no-repeat center center/cover;
      }
      .right {
        position: relative;
        width: 286px;
        height: 122px;
        background: url('~@/assets/images/img_student_01.png') no-repeat center center/cover;
        span {
          position: absolute;
          top: 58px;
          right: 40px;
        }
      }
      .rightSelected {
        color: #fff;
        background: url('~@/assets/images/img_student_02.png') no-repeat center center/cover;
      }
    }
    .form {
      width: 614px;
      height: 426px;
      margin: 60px auto 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-around;
      .van-field {
        background: #F6F6F6;
        height: 84px;
        /deep/ .van-field__left-icon {
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 26px 20px;
          img {
            width: 32px;
            height: 32px;
          }
          .arrow {
            position: absolute;
            top: 6px;
            right: 0;
            margin-top: 20%;
            width: 14px;
            height: 14px;
            transition: all .5s;
            transform:rotate(180deg);
          }
          .arrowTop {
            transition: all .5s;
            transform:rotate(360deg);
          }
        }
      }
    }
    .submit {
      display: block;
      margin: 70px auto 0;
      width: 450px;
      height: 76px;
      background: linear-gradient(90deg, #2E86FF 0%, #5FA9FF 100%);
      box-shadow: 0px 6px 40px rgba(95, 169, 255, 0.3);
      border-radius: 44px;
      font-size: 28px;
      font-weight: 500;
      line-height: 46px;
      color: #fff;
    }
  }
  .checkbox {
    margin: 102px auto 0;
    height: 32px;
    font-size: 22px;
    font-weight: 500;
    color: #999;
    display: flex;
    align-items: center;
    justify-content: center;
    span {
      display: inline-block;
      width: 28px;
      height: 28px;
      background-color: #fff;
      border: 1px #ccc solid;
      margin-right: 10px;
      margin-top: 4px;
    }
    .link{
      color: #5BA7FF;
    }
    .checked {
      border: none;
      background: url('~@/assets/images/icon_checked_01.png') no-repeat center center/cover;
    }
  }
}
</style>